/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Min_AgeInputs */

const en_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended Age`)
};

const es_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edad recomendada`)
};

const fr_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Âge recommandé`)
};

const de_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersempfehlung`)
};

const ja_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象年齢`)
};

const zh_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐年龄`)
};

const ar_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العمر الموصى به`)
};

const id_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekomendasi Usia`)
};

const it_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Età Consigliata`)
};

const ru_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемый возраст`)
};

const pt_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idade Recomendada`)
};

const ko_field_min_age = /** @type {(inputs: Field_Min_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`권장 연령`)
};

/**
* | output |
* | --- |
* | "Recommended Age" |
*
* @param {Field_Min_AgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_min_age = /** @type {((inputs?: Field_Min_AgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Min_AgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_min_age(inputs)
	if (locale === "es") return es_field_min_age(inputs)
	if (locale === "fr") return fr_field_min_age(inputs)
	if (locale === "de") return de_field_min_age(inputs)
	if (locale === "ja") return ja_field_min_age(inputs)
	if (locale === "zh") return zh_field_min_age(inputs)
	if (locale === "ar") return ar_field_min_age(inputs)
	if (locale === "id") return id_field_min_age(inputs)
	if (locale === "it") return it_field_min_age(inputs)
	if (locale === "ru") return ru_field_min_age(inputs)
	if (locale === "pt") return pt_field_min_age(inputs)
	return ko_field_min_age(inputs)
});